import { Component, Vue } from 'vue-property-decorator'
import CAOG1010Service from './CAOG1010Service'
import CAOG1010ViewModel from './CAOG1010ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import { fixedContent } from '@/assets/js/main.js'

@Component({
  name: 'CAOG1010',
  components: {}
  })
export default class CAOG1010Controller extends Vue {
  private xssFilterOptions = XSSFilterOptions
  private caog1010Service: CAOG1010Service = new CAOG1010Service()
  private caog1010ViewModel: CAOG1010ViewModel = {
    dictSumInfo: null,
    searchTopWord: 'あ行',
    totalRecord: null,
    filteredDictList: [
      {
        dictTitle: '',
        dictCont: ''
      }
    ]
  }

  /**
   * 画面要素描画後処理
   */
  mounted() {
    fixedContent()
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const caoa1010ResponseModel = await this.caog1010Service.callAPICAOA1010()

    this.caog1010ViewModel.dictSumInfo = caoa1010ResponseModel.dictSumInfo

    const faqFilterdictLst = this.caog1010Service.filterByInitial(
      this.caog1010ViewModel.dictSumInfo,
      this.caog1010ViewModel.searchTopWord
    )

    this.caog1010ViewModel.filteredDictList = faqFilterdictLst
    this.caog1010ViewModel.totalRecord = faqFilterdictLst.length
  }

  /**
   * 頭文字ボタン押下
   * @param topWord
   */
  private clickFilterByInitial(topWord: string) {
    this.caog1010ViewModel.searchTopWord = topWord
    const faqFilterdictLst = this.caog1010Service.filterByInitial(
      this.caog1010ViewModel.dictSumInfo,
      this.caog1010ViewModel.searchTopWord
    )
    this.caog1010ViewModel.filteredDictList = faqFilterdictLst
    this.caog1010ViewModel.totalRecord = faqFilterdictLst.length
  }
}
